import ProductSans from './ProductSans-Regular.woff';
import ProductSans2 from './ProductSans-Regular.woff2';

const Fonts = {
  ProductSans,
  ProductSans2,
};

export default Fonts;
